import { AgentDefinition } from 'app/modules/agent-library/models/agent-definition.model';

/** The id of the default target: DEO itself, which is not an agent. */
export const DEO_TARGET_ID = 'deo';

/**
 * One row of the widget's "Talking to" selector.
 *
 * `agent` is present for every row except DEO's, and it is what lets the agent rows render through
 * the shared `<gains-agent-card variant="compact">` instead of a second card implementation. DEO
 * has no `AgentDefinition` and keeps its own mark colours, so its row is hand-rolled — the one
 * place the two differ.
 */
export interface TalkingToTarget {
  /** `deo`, or an `AgentDefinition.id`. */
  id: string;

  label: string;

  /** Initials, from `AgentsService.resolveAgentMark`, or the literal `DEO`. */
  mark: string;

  agent?: AgentDefinition;
}
